export default __webpack_public_path__ + "media/zurb/img/placeholders/hero_image-19d76005978f9154ce1b08fc1ce46687.png";